import React from 'react';

import { useLanguage } from '@/hooks/useLanguage'

import { Container, Summary, Clauses, SeparatorSection } from './styles'
import { sanitize } from 'isomorphic-dompurify';

import Image from 'next/image';

import customersFeedbackImg from '@/assets/images/feedback_banner/feedback_banner@2.png'

export function PrivacyPolicyTemplate() {
  const { content } = useLanguage()

  return (
    <>
      <Container>
        <h1>{content.privacyPolicy.title}</h1>
        <p>
          {content.privacyPolicy.body}
        </p>

        <section>
          <Summary>
            <ul>
              {content.privacyPolicy.terms.map((term) =>
                <li key={term.title}>
                  {term.title}
                </li>)}
            </ul>
          </Summary>

          <Clauses>
            {content.privacyPolicy.terms.map((term) => {
              return (
                <div key={term.title}>
                  <h6>{term.title}</h6>
                  <article dangerouslySetInnerHTML={{ __html: sanitize(term.text) }} />
                </div>
              )
            })}
          </Clauses>
        </section>
      </Container>
      <SeparatorSection>
        <Image
          className="background"
          src={customersFeedbackImg}
          alt="HomePage Illustration"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          loading="lazy"
        />
      </SeparatorSection>
    </>
  );
}
